// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutofillController from "./autofill_controller"
application.register("autofill", AutofillController)

import BookingCalendarController from "./booking_calendar_controller"
application.register("booking-calendar", BookingCalendarController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CheckboxCollectionController from "./checkbox_collection_controller"
application.register("checkbox-collection", CheckboxCollectionController)

import CourseMaterialAppInitiatorController from "./course_material_app_initiator_controller"
application.register("course-material-app-initiator", CourseMaterialAppInitiatorController)

import DropdownNavigatorController from "./dropdown_navigator_controller"
application.register("dropdown-navigator", DropdownNavigatorController)

import FieldMatcherController from "./field_matcher_controller"
application.register("field-matcher", FieldMatcherController)

import FormSubmitterController from "./form_submitter_controller"
application.register("form-submitter", FormSubmitterController)

import HtmlHelperController from "./html_helper_controller"
application.register("html-helper", HtmlHelperController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PhoneNumberValidatorController from "./phone_number_validator_controller"
application.register("phone-number-validator", PhoneNumberValidatorController)

import QuestionnaireInitiatorController from "./questionnaire_initiator_controller"
application.register("questionnaire-initiator", QuestionnaireInitiatorController)

import ScrollerController from "./scroller_controller"
application.register("scroller", ScrollerController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import PollerController from "./poller_controller"
application.register("poller", PollerController)

import WebPushNotificationController from "./web_push_notification_controller"
application.register("web-push-notification", WebPushNotificationController)

import WysiwygInitiatorController from "./wysiwyg_initiator_controller"
application.register("wysiwyg-initiator", WysiwygInitiatorController)
